import { Injectable, inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { AuthorizeService } from './authorize.service';

@Injectable({
	providedIn: 'root'
})
export class UnauthorizeGuard implements CanActivate {
	private authorize = inject(AuthorizeService);
	private router = inject(Router);

	canActivate(
		_next: ActivatedRouteSnapshot,
		_state: RouterStateSnapshot): Observable<boolean> {
		return this.authorize.authState$.pipe(
			filter(s => s !== 'unknown'),
			take(1),
			map(s => {
				if (s === 'authenticated') {
					this.router.navigate(['/dashboard']);
					return false;
				}
				return true;
			})
		);
	}
}
